import React, { useEffect, useState } from "react";
import "../Styles/SidebarMatches.css"; // Custom CSS file
import { calculateAge, getDefaultProfileIcon } from "../utils/commonFunctions";
import { get_access_request, update_match_status } from "../api/serverWrapper";
import ForwardClientPopup from "./ForwardClientPopup";
import Profile from "./../components/Profile";

const tabs = ["New", "Forwarded to client", "Saved", "Approved profiles"];

export const Liked = 1;
export const UnLiked = 2;
export const Saved = 3;
export const Shared = 4;
export const Approved = 5;

const AccecptedProileImg = 2;

const defaultIcon = require("../assests/images/defalut_female_icon.png");

const SidebarMatches = ({
  data,
  allIcons,
  loadMathesData,
  client,
  MoveToApprovedClient,
  handleProfileId,
  loading,
  setLoading,
  isAgentLogin,
}) => {
  const [activeTab, setActiveTab] = useState("New");
  const [searchQuery, setSearchQuery] = useState("");
  const [openForwardClientPopup, setOpenForwardClientPopup] = useState(false);
  const [profileId, setProfileId] = useState(null);

  const filterDataByTab = () => {
    let filtered = [];

    if (activeTab === "New") {
      filtered = data.filter(
        (item) =>
          [Liked].includes(item.MatchInfo?.C1AgentStatus) &&
          item.MatchInfo?.Client1Status !== Approved,
      );
    } else if (activeTab === "Saved") {
      filtered = data.filter((item) => item.MatchInfo?.C1AgentStatus === Saved);
    } else if (activeTab === "Forwarded to client") {
      filtered = data.filter(
        (item) =>
          item.MatchInfo?.C1AgentStatus === Shared &&
          item.MatchInfo?.Client1Status !== Approved,
      );
    } else if (activeTab === "Approved profiles") {
      filtered = data.filter(
        (item) => item.MatchInfo?.Client1Status === Approved,
      );
    } else {
      filtered = data;
    }

    // Apply search filter
    if (searchQuery.trim()) {
      const lowerQuery = searchQuery.toLowerCase();
      filtered = filtered.filter((item) => {
        const fullName = `${item?.User?.FirstName ?? ""} ${
          item?.User?.LastName ?? ""
        }`.toLowerCase();
        return fullName.includes(lowerQuery);
      });
    }

    console.log(filtered[0]);

    return filtered;
  };

  const filteredMatches = filterDataByTab();

  const perfectMatches = filteredMatches.filter(
    // (item) => item.MatchInfo?.MatchLevel === 1,
    (item) => item.MatchInfo?.IsPerfectMatch === true,
  );

  const otherMatches = filteredMatches.filter(
    // (item) => item.MatchInfo?.MatchLevel === 2,
    (item) => item.MatchInfo?.IsPerfectMatch !== true,
  );

  const getContact = (item) =>
    item?.AgentContactNumber?.trim?.() ||
    item?.BusinessDetails?.PhoneNumber?.trim?.() ||
    item?.BusinessDetails?.EMail?.trim?.();

  const handleIconPress = (icon, MatchId, item) => {
    setProfileId(item);
    if (icon === "like_icon") {
      setActiveTab("Forwarded to client");
      let C1AgentStatus = Shared; //Liked
      updateMatchStatus(MatchId, C1AgentStatus);
      // MoveToApprovedClient();
    }
    if (icon === "dislike_icon") {
      let C1AgentStatus = UnLiked; //UnLiked
      updateMatchStatus(MatchId, C1AgentStatus, true);
    }
    if (icon === "share_icon") {
      // let C1AgentStatus = Shared; //saved
      // updateMatchStatus(MatchId, C1AgentStatus);
      // setActiveTab("Forwarded to client");
      handelForwardClientPopup();
    }
    if (icon === "copy_icon") {
      console.log("MatchId", MatchId);
      let C1AgentStatus = Saved; //Shared
      updateMatchStatus(MatchId, C1AgentStatus);
      setActiveTab("Saved");
    }
  };

  const handelForwardClientPopup = () => {
    setOpenForwardClientPopup(!openForwardClientPopup);
  };

  const updateMatchStatus = async (MatchId, C1AgentStatus, dislike) => {
    let data = {
      MatchId: MatchId,
      C1AgentStatus: C1AgentStatus,
      // C2AgentStatus: Joi.number().optional(),
      Client1Status: dislike ? C1AgentStatus : null,
      // Client2Status: Joi.number().optional(),
    };

    if (!data.Client1Status) {
      delete data.Client1Status;
    }
    try {
      setLoading(true);
      let res = await update_match_status(data);
      console.log(res);
      if (res.code === 200) {
        await loadMathesData(client?.ProfileId);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getVisibleIcons = () => {
    if (activeTab === "Saved") {
      // Omit copy_icon in Saved tab
      const { copy_icon, ...filteredIcons } = allIcons;
      return filteredIcons;
    }

    if (activeTab === "Forwarded to client") {
      // Omit share_icon in Forwarded tab
      const { like_icon, ...filteredIcons } = allIcons;
      return filteredIcons;
    }

    if (activeTab === "Approved profiles") {
      // Omit share_icon in Forwarded tab
      const { like_icon, ...filteredIcons } = allIcons;
      return filteredIcons;
    }

    // Default: show all icons
    return allIcons;
  };

  const handleClick = (id) => {
    handleProfileId(id);
  };

  const renderMatchList = (matches) => {
    return matches.map((item, i) => (
      <div
        key={i}
        className="match-card click-effect"
        onClick={() => handleClick(item.ProfileId)}
      >
        <div className="match-top">
          <img
            src={
              item?.User?.ProfilePhotoUrl || getDefaultProfileIcon(item?.User)
            }
            alt="Profile"
            className={
              item.IsPhotoVisible ||
              item.VisibilityStatus === AccecptedProileImg ||
              (isAgentLogin ? item?.AgentId === client?.AgentId : false)
                ? "match-img"
                : "match-img blur-profile-img"
            }
          />

          <div>
            <div
              className={
                item.MatchInfo?.C1AgentStatus === Liked
                  ? "client-name-for-like"
                  : "client-name"
              }
            >
              {item?.User?.FirstName} {item?.User?.LastName},{" "}
              {calculateAge(item?.User?.DOB)}
            </div>

            <div className="client-agent">
              {item?.BusinessDetails?.BusinessName ? "Agent" : "Client"} :{" "}
              {item?.BusinessDetails?.BusinessName ||
                item?.BusinessDetails?.FirstName ||
                ""}{" "}
              {item.BusinessDetails?.BusinessAddress}
            </div>

            {item.MatchInfo?.C1AgentStatus === Saved && (
              <div className="client-agent-no">
                {item?.BusinessDetails?.BusinessName ? "Agent" : "Client"}{" "}
                {item?.AgentContactNumber || item?.BusinessDetails?.PhoneNumber
                  ? "contact number:"
                  : "Email:"}{" "}
                {getContact(item) || "N/A"}
              </div>
            )}

            {item.MatchInfo?.Client1Status === Approved && (
              <div className="client-agent-no">Approved Profile</div>
            )}
          </div>
        </div>

        {item.MatchInfo?.C1AgentStatus === Liked && (
          <div className="match-criteria">
            Matched on: Caste | Appearance | Salary req | 3 more +
          </div>
        )}

        <div className="hover-icons">
          {Object.entries(getVisibleIcons()).map(
            ([iconKey, iconSrc], index) => (
              <button
                key={index}
                className="icon-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleIconPress(iconKey, item.MatchInfo.MatchId, item);
                }}
              >
                <img src={iconSrc} alt={iconKey} />
              </button>
            ),
          )}
        </div>
      </div>
    ));
  };

  return (
    <div className="sidebar-container ms-2">
      <div id="custom-toast-forward">Forwarded successfully!</div>
      {/* Tabs */}
      <div className="tabs">
        {tabs.map((tab, i) => (
          <button
            key={tab}
            className={`tab-btn ${
              activeTab === tab ? "active" : ""
            } click-effect`}
            onClick={() => setActiveTab(tab)}
          >
            {i === 1 ? (isAgentLogin ? tab : "Forwarded to contact") : tab}
          </button>
        ))}
      </div>

      {/* Search */}
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search match"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <span className="search-icon">
          <svg
            width="21"
            height="19"
            viewBox="0 0 21 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="8.35998"
              cy="8.18786"
              r="6.04251"
              transform="rotate(19.726 8.35998 8.18786)"
              stroke="#5E5C68"
              stroke-width="0.720124"
            />
            <path
              d="M12.2871 13.6152L15.6146 18.1292"
              stroke="#5E5C68"
              stroke-width="1.44025"
              stroke-linecap="round"
            />
          </svg>
        </span>
      </div>

      {/* Match List */}

      {/* <div className="group-matchs-title">Perfect matches </div> */}

      <div className="match-list">
        {loading ? (
          <div className="loading-state skeleton">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="skeleton-card">
                <div className="skeleton-left" />
                <div className="skeleton-right">
                  <div className="skeleton-line short" />
                  <div className="skeleton-line" />
                  <div className="skeleton-line small" />
                </div>
              </div>
            ))}
          </div>
        ) : filteredMatches.length === 0 ? (
          <div className="no-matches">
            {activeTab === "New" && (
              <p>
                No profiles found, Refine your preferences to expand your search
              </p>
            )}
            {activeTab === "Forwarded to client" && (
              <p>No forwarded clients yet.</p>
            )}
            {activeTab === "Saved" && <p>No saved clients found.</p>}
            {activeTab === "Approved profiles" && <p>No Approved profiles.</p>}
          </div>
        ) : activeTab === "New" ? (
          <>
            {perfectMatches.length > 0 && (
              <>
                <div className="group-matchs-title">Perfect Matches</div>

                {renderMatchList(perfectMatches)}
              </>
            )}

            {otherMatches.length > 0 && (
              <>
                <div className="group-matchs-title-secondary   mt-3">
                  You can also check
                </div>

                {renderMatchList(otherMatches)}
              </>
            )}
          </>
        ) : (
          renderMatchList(filteredMatches)
        )}
      </div>

      {openForwardClientPopup && data && (
        <ForwardClientPopup
          clients={data}
          profileId={profileId}
          handelForwardClientPopup={handelForwardClientPopup}
          ClientId={client.ProfileId}
          isAgentLogin={isAgentLogin}
        />
      )}
    </div>
  );
};

export default SidebarMatches;
